/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Clock': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm4.2 14.2L9 11V5h1.5v5.2l4.5 2.7-.8 1.3z" _fill="#00204D"/>'
  }
})
